import type { PollService } from "@busbud/core-types";

const UTM_PARAMS = ["utm_source", "utm_medium", "utm_campaign"] as const;

export function getWindowPollServiceSearchParams(): Partial<PollService.API.SearchQueryParams> {
  const window_search_params = new URLSearchParams(window.location.search);
  const poll_query_params = new URLSearchParams();
  UTM_PARAMS.forEach(param => {
    if (window_search_params.has(param)) {
      poll_query_params.set(param, window_search_params.get(param)!);
    }
  });

  return Object.fromEntries(poll_query_params.entries());
}
